module.exports = __webpack_public_path__ + "static/media/4.4086e7fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/beards/4.png
// module id = 1180
// module chunks = 0